import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
import ArrowForward from "@material-ui/icons/ArrowForward";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import Loading from '../../components/Loading/Loading.jsx';
import Api from "../../api/Api.js";
import AuthEndpoints from "../../api/AuthEndpoints.js";
import { withGoogleReCaptcha } from "react-google-recaptcha-v3";
import NotificationModal from "../../components/Modal/NotificationModal.jsx";
import Success from "../../components/Typography/Success.jsx";

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        this.state = {
            cardAnimaton: "cardHidden",
            username: '',
            usernameInvalid: false,
            loading: false,
            success: false
        };
    }
    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this.timeOutFunction = setTimeout(
            function () {
                this.setState({ cardAnimaton: "" });
            }.bind(this),
            700
        );
    }
    componentWillUnmount() {
        clearTimeout(this.timeOutFunction);
        this.timeOutFunction = null;
    }

    async submitReset() {
        if (!this.state.username) {
            this.setState({ usernameInvalid: true });
            return;
        }
        this.setState({ loading: true });
        //Request Reset
        const recaptcha_token = await this.props.googleReCaptchaProps.executeRecaptcha('reset');
        Api.post(AuthEndpoints.resetRequest, { username: this.state.username, recaptcha_token })
            .then(({ data }) => {
                if (data.valid) {
                    this.setState({ loading: false, success: true });
                } else {
                    this.setState({ loading: false, usernameInvalid: true });
                }
            }).catch((e) => {
                console.error(e);
                this.setState({ loading: false, usernameInvalid: true });
            })
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={6} md={4}>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <Card login className={classes[this.state.cardAnimaton]}>
                                <CardHeader
                                    className={`${classes.cardHeader} ${classes.textCenter}`}
                                    color="rose"
                                >
                                    <h4 className={classes.cardTitle}>Reset Password</h4>
                                </CardHeader>
                                <CardBody>
                                    <CustomInput
                                        labelText={(this.state.usernameInvalid ? "Invalid Email/Username" : "Email/Username")}
                                        id="email"
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <Email className={classes.inputAdornmentIcon} />
                                                </InputAdornment>
                                            ),
                                            onChange: (event) => {
                                                this.setState({ username: event.target.value, usernameInvalid: false });
                                            },
                                            onKeyPress: (e) => {
                                                if (e.key === 'Enter') {
                                                    this.submitReset();
                                                }
                                            },
                                            value: this.state.username
                                        }}
                                        error={this.state.usernameInvalid}
                                    />
                                </CardBody>
                                <CardFooter className={classes.justifyContentCenter}>
                                    {
                                        this.state.loading ?
                                            <div style={{ paddingBottom: 10 }}>
                                                <Loading />
                                            </div>
                                            :
                                            <Button key="reset" color="rose" simple size="lg" block onClick={() => this.submitReset()}>
                                                Reset&nbsp;&nbsp;<ArrowForward />
                                            </Button>
                                    }
                                </CardFooter>
                            </Card>
                        </form>
                        <NotificationModal 
                        open={this.state.success} 
                        close={() => {
                            localStorage.clear();
                            window.location.href = "/login"
                        }}
                            >
                            <Success><h3>Success!</h3></Success>
                            <p>
                                An email was sent to the associated account instructions
                            </p>
                        </NotificationModal>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

ResetPassword.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(loginPageStyle)(withGoogleReCaptcha(ResetPassword));
